import React, { useCallback, useEffect, useState } from 'react';

import { NotificationManager, StorageManager, TerminalApi, useApplicationState } from '@atlas/core';
import { Button, DefaultPopup, Icon, Label } from '@atlas/ui';

import { TERMINAL_LOGIN_UID_STORAGE_KEY } from 'src/common/constants';

const getLabels = isFailed => {
  if (isFailed) {
    return {
      btnPrimary: 'ok',
      icon: {
        cls: 'terminal-login-error-icon',
        name: 'error',
      },
      text: 'terminal_login_passed_description',
      title: 'terminal_login_passed_title',
    };
  } else {
    return {
      btnPrimary: 'submit',
      btnSecondary: 'cancel',
      icon: {
        cls: 'terminal-login-icon',
        name: 'login',
      },
      text: 'terminal_confirmation_login_description',
      title: 'terminal_confirmation_login_title',
    };
  }
};

const TerminalLoginPopup = ({ data: { onClose = () => {}, sessionUid = '' }, id }) => {
  const { authenticated, resolved } = useApplicationState();
  const [isFailed, setFailed] = useState(false);
  const labels = getLabels(isFailed);

  const hidePopup = useCallback(() => {
    StorageManager.setItem(
      TERMINAL_LOGIN_UID_STORAGE_KEY,
      JSON.stringify({
        finishTime: 0,
        sessionUid,
      }),
    );
  }, [sessionUid]);

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
    hidePopup();
    onClose();
  }, [hidePopup, id, onClose]);

  useEffect(() => {
    if (!sessionUid || (resolved && !authenticated)) {
      handleClose();
    }
  }, [handleClose, sessionUid, resolved, authenticated]);

  const submitBtn = useCallback(() => {
    TerminalApi.loginTerminal({
      uid: sessionUid,
    })
      .then(() => handleClose())
      .catch(error => {
        if (error?.code === 'NOT_FOUND') {
          setFailed(true);
        } else {
          handleClose();
        }
      })
      .finally(() => hidePopup());
  }, [sessionUid, handleClose, hidePopup]);

  if (!resolved || !authenticated) {
    return null;
  }

  return (
    <DefaultPopup className="terminal-login" onClose={handleClose}>
      <div className="popup__content">
        <Icon className={labels.icon.cls} height={32} name={labels.icon.name} width={32} />
        <Label className="popup__title" message={labels.title} />
        <Label className="popup__text" message={labels.text} />
      </div>

      <div className="popup__footer">
        {!!labels.btnSecondary && (
          <Button
            className="secondary big block"
            label={labels.btnSecondary}
            onClick={handleClose}
          />
        )}
        {!!labels.btnPrimary && (
          <Button
            className="primary big block"
            label={labels.btnPrimary}
            onClick={isFailed ? handleClose : submitBtn}
          />
        )}
      </div>
    </DefaultPopup>
  );
};

export default TerminalLoginPopup;
